export default __webpack_public_path__ + "static/media/musician.f7984acd.svg";